import { Engine, EngineOptions } from 'babylonjs' // This is core lib
import { Context3D } from '../3d-context'
import { MissingCameraError } from '../errors'

interface IEngineOptions extends EngineOptions {}

// https://doc.babylonjs.com/typedoc/classes/babylon.engine
/**
 * Creates engine
 */
export function setupEngine(
  options: IEngineOptions,
  canvas3D: HTMLCanvasElement
) {
  const engine = new Engine(canvas3D, true, {
    preserveDrawingBuffer: options?.preserveDrawingBuffer || true,
    stencil: options?.stencil || true,
  })

  engine.displayLoadingUI()
  customLoadingUI()

  Context3D.set({ engine, canvas3D })

  return engine
}

export function customLoadingUIText(text: string, context = Context3D.get()) {
  if (!context.engine) return

  context.engine.loadingUIText = text
}

export function customLoadingUI(lowProfile?: boolean) {
  // CUSTOM LOADING ICON
  const babylonjsLoadingDiv = window.document.querySelector(
    '#babylonjsLoadingDiv'
  ) as HTMLDivElement
  if (!babylonjsLoadingDiv) return

  const iconLoading = babylonjsLoadingDiv?.querySelector(
    'img'
  ) as HTMLImageElement
  iconLoading.setAttribute('src', '/BRIKL_LOGO.png')
  iconLoading.style.width = '115px'

  if (lowProfile) {
    babylonjsLoadingDiv.style.opacity = '0.5'
  }

  // CUSTOM LOADING ICON
}

/**
 * Start run the engine
 */
export function runRenderLoop(context = Context3D.get()) {
  const { scene, engine, fpsIndicator } = context
  if (!scene) return

  if (scene.cameras?.length < 1) throw new MissingCameraError()

  engine?.runRenderLoop(() => {
    scene.render()

    if (fpsIndicator)
      fpsIndicator.innerHTML = engine.getFps().toFixed() + ' fps' // show fps indicator
  })
}
